import React from 'react';
import { ENABLE_GIFT_CARDS } from '../../constants/featureFlags';
import { useNavigate, Link } from 'react-router-dom';
import { usePageContent } from '../../hooks/usePageContent';
import './index.module.css';

const GiftCardLandingPage = () => {
  const navigate = useNavigate();
  const { find } = usePageContent('gift-landing');
  const c = find('giftLanding') || {};
  const ledeHtml = c.ledeHtml || "<p>Looking for a gift that’s personal, fun and lasting? Custom plates are the perfect gift with hundreds of designs and combinations to choose from. Your special someone is sure to find one they love!</p><h3>Good to know:</h3><ul><li>Vouchers will be sent instantly via email when purchased</li><li>Valid for three years from the date of purchase</li><li>Gift vouchers start from $260</li></ul><p>See <a href=\"/terms\" target=\"_blank\">Terms &amp; Conditions</a>.</p>";
  return (
    <div id="content">
      <div className="row">
        <div className="page-header">
          <div className="page-header__content">
            <h1 className="page-header__title">{c.pageTitle || 'Buy a gift voucher'}</h1>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="gift-landing">
          <div className="gift-landing__content">
            <h2 className="gift-landing__title">{c.sectionTitle || 'Give a truly unique gift with custom plates'}</h2>
            <div className="gift-landing__lede rich-text" dangerouslySetInnerHTML={{ __html: ledeHtml }} />
            <div className="gift-landing__actions">
              <button
                className="button button--full-width"
                onClick={() => navigate('/gift-vouchers/personalise-voucher')}
              >
                <span className="button__text">{c.buyNowText || 'Buy now'}</span>
              </button>
              {ENABLE_GIFT_CARDS && (
                <div style={{ marginTop: '10px' }}>
                  <Link to="/gift-vouchers/balance" className="button button--full-width button--secondary">
                    <span className="button__text">{c.checkBalanceText || 'Check voucher balance'}</span>
                  </Link>
                </div>
              )}
            </div>
          </div>
          <div className="gift-landing__media">
            <img
              className="gift-landing__media-image"
              width="492"
              height="325"
              alt=""
              src={c.heroImageSrc || '/images/content/gift-voucher-landing.png'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiftCardLandingPage;
